import { render, staticRenderFns } from "./EmailCard.vue?vue&type=template&id=33ae1040"
import script from "./EmailCard.vue?vue&type=script&lang=js"
export * from "./EmailCard.vue?vue&type=script&lang=js"
import style0 from "./EmailCard.vue?vue&type=style&index=0&id=33ae1040&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports